import { Axios } from "../../../../axios";

export * from "../../base/store/actions";

export function send_file({ commit, rootGetters }, payload) {
	let formData = new FormData();
	formData.append("file", payload.file);
	formData.append("app_id", rootGetters.active_application_id);
	formData.append("q_slug", payload.slug);

	Axios.post("/question/file", formData)
		.then(function() {
			commit(payload.slug + "/set_error_message", "", { root: true });
			commit(payload.slug + "/set_answer", payload.file.name, { root: true });
		})
		.catch(function(error) {
			if (error.response.status !== 400) {
				commit(
					payload.slug + "/set_error_message",
					"Unable to save your response.",
					{ root: true }
				);
			} else {
				let errors = error.response.data.join(", ");
				commit(payload.slug + "/set_error_message", errors, { root: true });
			}
		});
}

export function delete_file({ dispatch, commit, rootGetters }, question_slug) {
	Axios.delete(
		"/question/file/" + question_slug + "/" + rootGetters.active_application_id
	)
		.then(function() {
			commit(question_slug + "/set_error_message", "", { root: true });
			commit(question_slug + "/set_answer", "", { root: true });
		})
		.catch(function(error) {
			if (error.response.status === 401) {
				dispatch("logout_user");
			} else if (error.response.status !== 400) {
				commit(
					question_slug + "/set_error_message",
					"Unable to delete your file.",
					{ root: true }
				);
			} else {
				let errors = error.response.data.join(", ");
				commit(question_slug + "/set_error_message", errors, { root: true });
			}
		});
}
